module.exports = __webpack_public_path__ + "static/media/careers-page-grid2.1fb34bb7.png";